import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancelled() {
  return (
    <div className="min-h-screen bg-artsy-background flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md">
        <div className="card-pricing text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-slate-900 mb-2">Payment Cancelled</h1>
          <p className="font-body text-slate-600 mb-6">
            Your payment was cancelled. No charges were made. Feel free to try again when you're ready.
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/art-club" className="btn-primary" data-testid="back-to-classes">
              Back to Classes
            </Link>
            <Link to="/" className="btn-outline inline-flex items-center justify-center gap-2" data-testid="back-home">
              <ArrowLeft className="w-5 h-5" /> Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
